import { DisplayField } from '../fields/Styles';
import { getHubDisplayStatus, getHubStatus, getHubStatusColor } from '../utils/connectionStatus';
import { HubIcon } from '../styling/Icons';
import { actionTypes } from '../utils/installationTypes';
import HubAggregatedError, { hasAggregatedError } from './HubAggregatedError';
import StatusField from '../fields/StatusField';
import { hideInList } from '../tableUtils';
import { getHubDisplayName, hasZigbeeNetwork } from './hubUtils';
import ZigbeeConfigButton, { ZigbeeSetupField } from './actions/ZigbeeConfig';
import NetworkConfigField from './fields/NetworkConfigField';
import SystemActionsField from './fields/SystemActionsField';

const idField = 'hubId';

export const getHubTableProps = ({ hubs, processors, sensors, customerId, serverStatus, displayMode }) => {

    const getColumns = (hubs) => [{
        displayName: 'Name',
        key: 'name',
        render: (hub) => <DisplayField>{getHubDisplayName(hub)}</DisplayField>
    }, {
        displayName: 'Id',
        key: 'hubId',
        render: (hub) => <DisplayField>{hub.hubId}</DisplayField>
    }, {
        displayName: 'Status',
        key: 'status',
        hide: hideInList(displayMode),
        render: (hub) => {
            const listItemProps = getListItemProps(hub)
            return <StatusField
                displayStatus={listItemProps.displayStatus}
                statusColor={listItemProps.statusColor}
                error={listItemProps.error}
            />
        }
    }, {
        displayName: 'Connection type',
        key: 'connectionType',
        render: (hub) => <DisplayField>{hub.connectionType}</DisplayField>
    }, {
        displayName: 'Ip address',
        key: 'ipAddress',
        form: true,
        render: (hub) => (
            <DisplayField>{hub.ipAddress}</DisplayField>
        )
    }, {
        displayName: 'Network config',
        key: 'networkConfig',
        form: true,
        render: (hub, updateHub) => (
            <NetworkConfigField
                hub={hub}
                updateHub={updateHub}
                customerId={customerId}
            />
        )
    }, {
        displayName: 'Version',
        key: 'programVersion',
        render: (hub) => <DisplayField>{hub.programVersion}</DisplayField>
    }, {
        displayName: 'Zigbee Setup',
        key: 'zigbeeConfig',
        render: (hub) => (
            <ZigbeeSetupField hub={hub} />
        )
    }, {
        displayName: 'System',
        key: 'systemActions',
        render: (hub) => (
            <SystemActionsField hub={hub} />
        )
    }];

    const getActions = (hub) => [{
        key: 'zigbeeConfig',
        type: actionTypes.PRIMARY,
        hide: hasZigbeeNetwork(hub),
        render: () => (
            <ZigbeeConfigButton hub={hub} />
        )
    }]

    const getListItemProps = (hub) => {
        const hubProcessors = processors?.filter(processor => processor.hubId === hub.hubId);
        const hubSensors = sensors?.filter(sensor => sensor.hubId === hub.hubId);
        const status = getHubStatus(hub, serverStatus, hubProcessors, hubSensors);
        return {
            displayName: getHubDisplayName(hub),
            displayStatus: getHubDisplayStatus(status),
            statusColor: getHubStatusColor(status),
            error: hasAggregatedError(status, hubSensors, hubProcessors) && <HubAggregatedError
                hubStatus={status}
                processors={hubProcessors}
                sensors={hubSensors}
            />,
            Icon: HubIcon
        }
    }

    async function saveObjects(changedHubs) {
        try {
            console.log('Save hub placeholder', changedHubs);
        } catch (err) {
            console.log('save error', err);
        }
    }

    const getPlaceholder = () => {
        return <div>
            <p>No hubs have been added</p>
        </div>
    }

    return {
        title: 'Hubs',
        getColumns,
        parentObjects: hubs,
        getListItemProps,
        idField,
        saveObjects,
        getActions,
        getPlaceholder
    }
}